<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import TokenizedImage from "#lib/components/TokenizedImage.svelte";
	import type { ModuleItemProps } from "#lib/components/flow/viewer/types.js";
	import { getAssetRef, getIconUrl } from "#lib/components/flow/viewer/utils.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");
	const assets: Writable<Record<string, AssetLoad>> = getContext("assets");

	const { suite, module, mode, readOnly, classes, onShow }: ModuleItemProps = $props();

	const ref = $derived(getAssetRef($suite, module));
	const iconUrl = $derived(getIconUrl($assets, module.key, ref, mode));

	function handleShow() {
		onShow?.(module);
	}
</script>

<button data-flow-button type="button" disabled={readOnly} onclick={handleShow} class={twMerge("flex w-full max-w-100 cursor-pointer flex-col overflow-hidden rounded-2xl bg-white p-0", classes.borderClass, classes.readOnlyClass)} class:!opacity-50={ref?.disabled}>
	<div class="relative flex aspect-[2.57] w-full grow items-center justify-center">
		<TokenizedImage provider={$tokenProvider} src={iconUrl} {mode} />
	</div>
</button>
